import { VideoScroller, type VideoItem } from './VideoScroller';
import { FadeUp } from '../primitives/FadeUp';

const SYSTEM_DEMOS: readonly VideoItem[] = [
  { title: 'Competitor Scan Walkthrough', desc: 'What I pull, and what it tells you' },
  { title: 'Objection Miner', desc: 'From a real sales call to a queued post' },
  { title: 'The Content Calendar', desc: 'A month, queued and waiting on approval' },
];

const PRODUCT_WALKTHROUGHS: readonly VideoItem[] = [
  { title: 'System Architecture', desc: 'How everything connects' },
  { title: 'Speed-to-Lead Agent', desc: 'Form submit to booked, end to end' },
  { title: 'Reputation Agent', desc: 'Job complete to review request' },
  { title: 'Meta Ads', desc: 'Running against the same content' },
  { title: 'The Weekly Report', desc: 'What worked, and why it worked' },
];

interface VideoGalleryProps {
  isMobile: boolean;
}

/**
 * The two-rail video gallery inside the proof section.
 *
 * These are system demos, not client case studies: no client has run under
 * Content OS terms yet, so nothing here implies results I cannot evidence.
 */
export function VideoGallery({ isMobile }: VideoGalleryProps) {
  return (
    <FadeUp delay={80}>
      <div style={{ marginBottom: 32 }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'minmax(0, 1fr) minmax(0, 1fr)',
            gap: isMobile ? 32 : 28,
          }}
        >
          <VideoScroller title="System Demos" videos={SYSTEM_DEMOS} />
          <VideoScroller title="Product Walkthroughs" videos={PRODUCT_WALKTHROUGHS} />
        </div>
      </div>
    </FadeUp>
  );
}
